import React, { SVGProps } from "react";

type DoubleLineMenuProps = SVGProps<SVGSVGElement>;

export const SmallDoubleArrowLine = (props: DoubleLineMenuProps) => (
  <svg
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6013_6573)">
      <path
        d="M6.9395 2.93967L2 7.87717L2.709 8.58417L7.6465 3.64667C7.74027 3.55293 7.86742 3.50027 8 3.50027C8.13258 3.50027 8.25974 3.55293 8.3535 3.64667L13.3 8.59067L14.007 7.88367L9.063 2.93967C8.78171 2.65846 8.40025 2.50049 8.0025 2.50049C7.60476 2.50049 7.22329 2.65846 6.942 2.93967H6.9395Z"
        fill="currentColor"
      />
      <path
        d="M7.64628 7.23265L2.00928 12.8692L2.71628 13.5767L7.99978 8.29315L13.2888 13.5822L13.9963 12.8752L8.35328 7.23265C8.25951 7.13892 8.13236 7.08626 7.99978 7.08626C7.8672 7.08626 7.74004 7.13892 7.64628 7.23265Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6013_6573">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="matrix(0 -1 1 0 2 14)"
        />
      </clipPath>
    </defs>
  </svg>
);
